import { Redirect, Route, Switch, useRouteMatch } from 'react-router';
import { ServicesProvider, useOrganization } from '@signavio/effektif-api';
import Create from './create';
import ProcessEdit from './edit';
import Examples from './examples';
import Overview from './overview';
import { UI5Theme } from '@signavio/effektif-commons';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Main() {
  const organization = useOrganization();
  const match = useRouteMatch();
  return /*#__PURE__*/_jsx(UI5Theme, {
    children: /*#__PURE__*/_jsx(ServicesProvider, {
      children: /*#__PURE__*/_jsxs(Switch, {
        children: [/*#__PURE__*/_jsx(Route, {
          path: `${match.url}/overview`,
          component: Overview
        }), /*#__PURE__*/_jsx(Route, {
          path: `${match.url}/create`,
          component: Create
        }), /*#__PURE__*/_jsx(Route, {
          path: `${match.url}/process/:workflowId`,
          component: ProcessEdit
        }), organization.workflowCreator && /*#__PURE__*/_jsx(Route, {
          path: `${match.url}/examples`,
          component: Examples
        }), /*#__PURE__*/_jsx(Redirect, {
          to: `${match.url}/overview`
        })]
      })
    })
  });
}
export default Main;